import React, { useEffect, useState } from 'react';
import { BaseOfflineModeBanner } from './base-offline-mode-banner';
import { createStyles } from '@/contexts/theme-context';
import {
  NetworkStatus,
  useNetworkStatus,
} from '@/contexts/network-status-context';
import { Platform, StyleProp, TextStyle, ViewStyle } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';
import { useNetworkGracePeriod } from '@/hooks/use-network-grace-period';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export const OfflineModeBanner: React.FC<Props> = ({
  containerStyle,
  textStyle,
}) => {
  const { networkStatus } = useNetworkStatus();
  const { setGraceTimeout, clearGraceTimeout } = useNetworkGracePeriod();
  const [showBanner, setShowBanner] = useState(false);
  const salesRepMode = useSalesRepMode();
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  useEffect(() => {
    if (networkStatus === NetworkStatus.DISCONNECTED) {
      setGraceTimeout(() => setShowBanner(true));
    } else {
      setShowBanner(false);
      clearGraceTimeout();
    }
    return () => clearGraceTimeout();
  }, [networkStatus, setGraceTimeout, clearGraceTimeout]);

  if (!showBanner) {
    return null;
  }

  const mobileWebPaddingTop = {
    paddingTop: Platform.OS === 'web' && isSmallLayout ? 4 : 0,
  };

  return (
    <BaseOfflineModeBanner
      containerStyle={[
        salesRepMode
          ? styles.baseDark
          : isSmallLayout
            ? styles.background
            : null,
        mobileWebPaddingTop,
        containerStyle,
      ]}
      textStyle={[salesRepMode ? styles.baseColor : undefined, textStyle]}
    />
  );
};

const useStyles = createStyles((theme) => ({
  background: {
    backgroundColor: theme.colors.background,
  },
  baseColor: {
    color: theme.colors.white,
  },
  baseDark: {
    backgroundColor: theme.colors.primary,
  },
}));
